import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateBuyGoldTransaction(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateBuyGoldTransactionAttempt', handleCreateBuyTransaction, api);
}

function* handleCreateBuyTransaction(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const draftId = reduxState.gold.createTransactionSummary.draftId;
    const {
        customerId,
        branchCode,
        salesPersonnelName,
        referralName,
        isEarmarkTransaction,
        earmarkEndDate,
    } = reduxState.gold.params.buyOrSellGoldParams;

    const { proof } = reduxState.gold.buyAndSellGold.goldPrices;

    const response = yield* call([api, api.createBuyGoldTransaction], {
        authToken,
        draftId,
        branchCode,
        customerId,
        crc: proof.crc,
        dsig: proof.dsig,
        salesPersonnelName,
        referralName,
        isEarmarkTransaction,
        earmarkEndDate,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldCreateBuyGoldTransactionFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success(SuccessMessages.GoldCreateBuyTransactionSuccess);
        yield put(combinedActions.goldSetIsBuyOrSellGoldModalOpen(false));
        yield put(combinedActions.goldCreateBuyGoldTransactionSuccess());
        yield put(combinedActions.goldGetTransactionListingAttempt());
    }
}
